export default __webpack_public_path__ + "static/media/18-flushed-face_1f633.6cc673fe.png";